import React, { useState, useMemo, useEffect } from 'react';
import { Breadcrumb } from "react-bootstrap";
import Toast from '../../UI/Toast/Toast';
import Graybg from '../../UI/Graybg';
import './QuestionIngestion.css';
import DataTable from './DataTable/Table';
import userService from '../../app/services/user.service';
import { toast } from 'react-toastify';
import UploadForm from './UploadForm';
import MediaCropping from './MediaCropping';
import DuplicateCheck from './DuplicateCheck';
import ViewQuestions from './ViewQuestions';

const QuestionIngestion = () => {
  const [fileType, setFileType] = useState('combined'); // 'combined' or 'separate'
  const [selectedTarget, setSelectedTarget] = useState('');
  const [activeTab, setActiveTab] = useState('upload'); // 'upload' or 'previous'
  const [currentStep, setCurrentStep] = useState(1); // 1: Start Ingestion, 2: Media Cropping, 3: Duplicate Check, 4: Final Review
  const [loading, setloading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [uploadId, setUploadId] = useState(null);
  const [prevData,setPrevData]=useState([]);
  const [currentStatus,setCurrentStatus]=useState(null);

  // Steps configuration - dynamically set active based on currentStep
  const steps = useMemo(() => [
    { number: 1, label: 'Start Ingestion', active: currentStep >= 1 },
    { number: 2, label: 'Media Cropping', active: currentStep >= 2 },
    { number: 3, label: 'Duplicate Check', active: currentStep >= 3 },
    { number: 4, label: 'Final Review', active: currentStep >= 4 }
  ], [currentStep]);

  useEffect(()=>{

    
      userService.prevUploadList()
      .then(res=>{
            console.log(res.pdf_list_result);
            setPrevData(res.pdf_list_result);       
      })
      .catch(err=>{
        console.log("Error",err)
      })
    
  },[activeTab,currentStep])

  const handleStartIngestion = (files) => {
    const { uploadedFile, questionFile, answerFile, solutionFile } = files;
  
    // ---------- Validation ----------
    if (!selectedTarget) {
      toast.error("Please select target");
      return;
    }
  
    if (fileType === "combined" && !uploadedFile) {
      toast.error("Please upload combined question PDF");
      return;
    }
  
    if (
      fileType === "separate" &&
      !questionFile &&
      !answerFile &&
      !solutionFile
    ) {
      toast.error("Please upload at least one file (Question / Answer / Solution)");
      return;
    }
    
  
    setloading(true);
  
    // ---------- COMBINED FILE ----------
    if (fileType === "combined") {
      const formData = new FormData();
      formData.append("target", selectedTarget);
      formData.append("fileType", fileType);
      formData.append("file", uploadedFile);
  
      userService.QuestionIngestionUpload(formData)
        .then((response) => {
          setloading(false);
          toast.success("Question Ingestion started successfully");
  
          const upload_id = response?.latest_upload_id;
  
          if (upload_id) {
            setUploadId(upload_id);
            // setCurrentStep(2);   // 👉 Move to Step 2
            setActiveTab('previous');

          } else {
            toast.error("Upload ID not found in response");
          }
        })
        .catch((err) => {
          console.log(err.response);
        
          if (err.response) {
            const status = err.response.status;
            
        
            if (status === 400) {
              toast.error(err.response.data?.message || "Bad Request");
            } else {
              toast.error("Something went wrong");
            }
          } else {
            toast.error("Network error");
          }
        
          setloading(false);
        });
  
      return;
    }
  
    // ---------- SEPARATE FILES ----------
    if (fileType === "separate") {
      const formData = new FormData();
      formData.append("target", selectedTarget);
      formData.append("question_pdf", questionFile);
      formData.append("answerkey_pdf", answerFile);
      formData.append("solution_pdf", solutionFile);
  
      userService.SeperateFileUpload(formData)
        .then((response) => {
          setloading(false);
          toast.success("Question Ingestion started successfully");
  
          const upload_id = response?.latest_upload_id;
  
          if (upload_id) {
            setUploadId(upload_id);
            // setCurrentStep(2);   // 👉 Move to Step 2
            setActiveTab("previous")
          } else {
            toast.error("Upload ID not found in response");
          }
        })
        .catch((err) => {
          console.log(err.response);
        
          if (err.response) {
            const status = err.response.status;
            
        
            if (status === 400) {
              toast.error(err.response.data?.message || "Bad Request");
            } else {
              toast.error("Something went wrong");
            }
          } else {
            toast.error("Network error");
          }
        
          setloading(false);
        });
    }
  };

  const fetchPdfList = () => {
    setRefreshing(true);
    userService.prevUploadList()
      .then(res => {
        console.log(res.pdf_list_result);
        setPrevData(res.pdf_list_result);
        setRefreshing(false);
        toast.success("Data refreshed successfully");
      })
      .catch(err => {
        console.log("Error", err);
        setRefreshing(false);
        toast.error("Failed to refresh data");
      });
  };
  
  
  // ==========================
  // COMMON SUCCESS HANDLER
  // ==========================
  const handleSuccess = (response) => {
    setloading(false);
    toast.success("Question Ingestion started successfully");
  
    console.log(response);
  
    const upload_id = response?.latest_upload_id;
  
    if (upload_id) {
      setUploadId(upload_id);
      setCurrentStep(2);
    } else {
      toast.error("Upload ID not found in response");
    }
  };
  
  // ==========================
  // COMMON ERROR HANDLER
  // ==========================
  const handleError = (err) => {
    console.log(err);
    toast.error("Something went wrong");
    setloading(false);
  };
  

  const handleStepNavigation = (step) => {
    setCurrentStep(step);
  
    if (step === 1) {
      setActiveTab("previous"); // optional if already
      fetchPdfList(); // ✅ FORCE API CALL
    }
  };

  const handleViewQuestionsFromPrevious = (id,step,current_status) => {
    if (!id) return;
    setUploadId(id);
    setCurrentStep(step);
    setCurrentStatus(current_status);
    

  };
  

  return (
    <>
      <Toast />
      <div className="section">
                        <div className="d-flex justify-content-between align-items-center h-100">
          <div>
            <h4>Question Ingestion | {currentStep === 1 ? 'Upload' : steps[currentStep - 1]?.label || 'Upload'}</h4>
            <Breadcrumb>
              <Breadcrumb.Item>Question Ingestion</Breadcrumb.Item>
              {currentStep >= 2 ? (
                <>
                  <Breadcrumb.Item>Upload</Breadcrumb.Item>
                  <Breadcrumb.Item active>{steps[currentStep - 1]?.label || 'Upload'}</Breadcrumb.Item>
                </>
              ) : (
                <Breadcrumb.Item active>Upload</Breadcrumb.Item>
              )}
            </Breadcrumb>
          </div>
        </div>
      </div>

      <Graybg>
        <div className="upload-container">
          {/* Stepper */}
          <div className="stepper-wrapper mb-4">
            {steps.map((step, index) => (
              <React.Fragment key={step.number}>
                <div className="stepper-item">
                  <div className={`step-number ${step.active ? 'active' : ''}`}>
                    {step.number}
                  </div>
                  <div className="step-label">{step.label}</div>
                </div>
                {index < steps.length - 1 && (
                  <div className={`step-line ${step.active ? 'active' : ''}`}></div>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* Tab Navigation - Only show when on step 1 */}
          {currentStep === 1 && (
            <div className="tab-navigation-wrapper mb-4">
              <div className="tab-navigation">
                <button
                  className={`tab-btn ${activeTab === 'upload' ? 'active' : ''}`}
                  onClick={() => setActiveTab('upload')}
                >
                  Upload
                </button>
                <button
                  className={`tab-btn ${activeTab === 'previous' ? 'active' : ''}`}
                  onClick={() => setActiveTab('previous')}
                >
                  Previous Uploads
                </button>
              </div>
            </div>
          )}

          {/* Render content based on current step and active tab */}
          {currentStep === 1 && activeTab === 'upload' ? (
            <UploadForm
              fileType={fileType}
              setFileType={setFileType}
              selectedTarget={selectedTarget}
              setSelectedTarget={setSelectedTarget}
              onStartIngestion={handleStartIngestion}
              loading={loading}
            />
          ) : currentStep === 1 && activeTab === 'previous' ? (
            <DataTable
              data={prevData}
              onViewQuestions={handleViewQuestionsFromPrevious}
              onNext={() => handleStepNavigation(2)}
              onRefresh={fetchPdfList}
            />
          ) : currentStep === 2 ? (
            <MediaCropping
              uploadId={uploadId}
              onNext={() => handleStepNavigation(3)}
              onPrevious={() => handleStepNavigation(1)}
              currentStatus={currentStatus}
              
            />
          ) : currentStep === 3 ? (
            <ViewQuestions
              uploadId={uploadId}
              onPrevious={() => handleStepNavigation(2)}
              onNext={() => handleStepNavigation(4)}
              GoToTable={() => handleStepNavigation(1)}
            />
          ) : currentStep === 4 ? (
            <DuplicateCheck
              uploadId={uploadId}
              onPrevious={() => handleStepNavigation(3)}
              GoToTable={() => handleStepNavigation(1)}
            />
            
          ) : null}
        </div>
      </Graybg>
    </>
  );
};

export default QuestionIngestion;